import { auth } from "./firebase";

export async function apiFetch(path, options = {}) {
    const user = auth.currentUser;
    const token = user ? await user.getIdToken() : null;

    const headers = {
        ...(options.headers || {}),
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    return fetch(`/api${path}`, {
        ...options,
        headers,
    });
}